import { render, staticRenderFns } from "./DetaliiComanda.vue?vue&type=template&id=7023cda4&scoped=true"
import script from "./DetaliiComanda.vue?vue&type=script&lang=js"
export * from "./DetaliiComanda.vue?vue&type=script&lang=js"
import style0 from "./DetaliiComanda.vue?vue&type=style&index=0&id=7023cda4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7023cda4",
  null
  
)

export default component.exports